import TextAnswer from '@/components/shared/answer-types/text/text.vue';
import SelectListAnswer from '@/components/shared/answer-types/select-list/select-list.vue';
import FileListAnswer from '@/components/shared/answer-types/file-list/file-list.vue';
import DateTimeAnswer from '@/components/shared/answer-types/datetime/datetime.vue';
import NumberAnswer from '@/components/shared/answer-types/number/number.vue';
import CheckBoxAnswer from '@/components/shared/answer-types/checkbox/checkbox.vue';
import CharityPietaHouse from '@/components/shared/pages/charity-pieta-house/charity-pieta-house.vue';
import TextListAnswer from '@/components/shared/answer-types/text-list/text-list.vue';

import { EventBus } from '@/services/Event.js';

export default {
    name: 'Field',
    inject: {
        getRaceId: { default: () => () => null }
    },
    props: { selected_field: Object, level: [String, Number], is_hidden: { type: Boolean, default: false } },
    components: {
        'file-list-answer': FileListAnswer,
        'text-answer': TextAnswer,
        'select-list-answer': SelectListAnswer,
        'date-time-answer': DateTimeAnswer,
        'number-answer': NumberAnswer,
        'checkbox-answer': CheckBoxAnswer,
        'charity-pieta-house': CharityPietaHouse,
        'text-list': TextListAnswer
    },
    data() {
        return {
            hidden: this.selected_field.isHidden ||
                (this.selected_field.visibleIfValues != null && this.selected_field.visibleIfValues.length > 0)
                || (this.selected_field.isHiddenIfNull && !this.selected_field.currentValue && (!this.selected_field.currentValueArray || !this.selected_field.currentValueArray.length)),

            text: 1,
            email: 2,
            link: 3,
            triathlon_id: 4,

            triathlon_ids: 5,

            rich_text: 6,

            date: 7,
            date_time: 8,

            check_box: 9,
            files_or_images: 10,

            select_list: 11,
            select_list_with_many_answers: 12,
            integer_number: 13,
            decimal_number: 14,

            text_list: 15,
            map: 16,
            static_link: 18,

            smallest: 'col-12', small: 'col-sm-12', medium: 'col-md-12', large: 'col-lg-12', largest: 'col-xl-12',

            charity_pieta_house: 1,
            link_copied: false
        };
    },
    computed: {
        registration_link() {
            var raceId = this.getRaceId();
            if (!raceId) return '';
            return window.location.origin + '/race-entry/' + raceId;
        },
        column_class_value() {
            if (this.selected_field.columnClasses) {
                return this.selected_field.columnClasses;
            }
            return `${this.largest} ${this.large} ${this.medium} ${this.small} ${this.smallest}`
        },
        date_time_type() {
            var result = "datetime";
            switch (this.selected_field.answerType) {
                case this.date:
                    result = "date";
                    break;
            }
            return result;
        },
        is_visible_text_list_answer() {
            var result = false;
            switch (this.selected_field.answerType) {
                case this.text_list:
                    result = true
                    break;
            }

            return result;
        },
        is_visible_static_link() {
            var result = false;
            switch (this.selected_field.answerType) {
                case this.static_link:
                    result = true
                    break;
            }

            return result;
        },
        is_visible_text_answer() {
            var result = false;
            switch (this.selected_field.answerType) {
                case this.text:
                case this.email:
                case this.link:
                case this.rich_text:
                case this.triathlon_id:
                    result = true
                    break;
            }

            return result;
        },
        is_visible_select_list_answer() {
            var result = false;
            switch (this.selected_field.answerType) {
                case this.select_list:
                    result = true
                    break;
            }

            return result;
        },
        is_visible_select_list_with_many_answer() {
            var result = false;
            switch (this.selected_field.answerType) {
                case this.select_list_with_many_answers:
                    result = true
                    break;
            }

            return result;
        },
        is_visible_date_time_answer() {
            var result = false;
            switch (this.selected_field.answerType) {
                case this.date_time:
                case this.date:
                    result = true
                    break;
            }

            return result;
        },
        is_visible_file_list_answer() {
            var result = false;
            switch (this.selected_field.answerType) {
                case this.files_or_images:
                    result = true
                    break;
            }

            return result;
        },
        is_visible_number_answer() {
            var result = false;
            switch (this.selected_field.answerType) {
                case this.decimal_number:
                case this.integer_number:
                    result = true
                    break;
            }

            return result;
        },
        is_visible_checkbox_answer() {
            var result = false;
            switch (this.selected_field.answerType) {
                case this.check_box:
                    result = this.selected_field.charityTypeEnum == null;
                    break;
            }

            return result;
        },
        is_visible_pieta_charity_answer() {
            var result = false;
            switch (this.selected_field.answerType) {
                case this.check_box:
                    result = this.selected_field.charityTypeEnum == this.charity_pieta_house;
                    break;
            }

            return result;
        },
    },
    methods: {
        copy_registration_link() {
            var self = this;
            navigator.clipboard.writeText(this.registration_link).then(function () {
                self.link_copied = true;
                setTimeout(function () { self.link_copied = false; }, 2000);
            }).catch(function () {
                self.$showError('Failed to copy link to clipboard');
            });
        },
        decide_visibility_update_way(previousHidden) {
            if (previousHidden != this.hidden) {
                this.update_visibility_commit();
            }
            else { //if visibily the same
                if (!this.is_hidden) { //in this case need to run action after value changed
                    EventBus.$emit(`handler-change-answer-id-${this.selected_field.enumByteValue}`);
                }
            }
        },
        update_visibility_multiple(array) {
            var previousHidden = this.hidden;
            this.hidden = !this.selected_field.visibleIfValues.some(r => array.includes(r));
            this.decide_visibility_update_way(previousHidden);
        },
        update_visibility(currentValue) {
            var previousHidden = this.hidden;
            this.hidden = !this.selected_field.visibleIfValues.includes(currentValue);
            this.decide_visibility_update_way(previousHidden);
        },
        update_visibility_commit() {
            if (this.hidden) {
                if (this.selected_field.changeVisibilityForFields && this.selected_field.changeVisibilityForFields.length) {
                    this.selected_field.changeVisibilityForFields.forEach(fieldId => EventBus.$emit(`update-visibility-field-id-${fieldId}`));
                }
            }

            this.$emit("update:is_hidden", this.hidden);
        },
    },
    mounted() {
        var self = this;
        EventBus.$off(`update-visibility-field-id-${this.selected_field.enumByteValue}`)
        EventBus.$on(`update-visibility-field-id-${this.selected_field.enumByteValue}`,
            (currentValue) => {
                self.update_visibility(currentValue);
            });

        EventBus.$off(`update-visibility-multiple-field-id-${this.selected_field.enumByteValue}`)
        EventBus.$on(`update-visibility-multiple-field-id-${this.selected_field.enumByteValue}`,
            (currentValue) => {
                self.update_visibility_multiple(currentValue);
            });

        this.$emit("update:is_hidden", this.hidden);

        EventBus.$off(`clear-value-field-id-${this.selected_field.enumByteValue}`)
        EventBus.$on(`clear-value-field-id-${this.selected_field.enumByteValue}`, () => {
            self.selected_field.currentValueArray = null;
            self.selected_field.currentValue = null;
        });

        EventBus.$off(`update-value-field-id-${this.selected_field.enumByteValue}`)
        EventBus.$on(`update-value-field-id-${this.selected_field.enumByteValue}`, (value) => {
            self.selected_field.currentValue = value;
        })
    }
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/races/view-race/field/field.js